import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'

// Redux
import { connect } from 'react-redux';

// Components
import DefaultAvatar from 'react-avatar';
import AuthDropdown from './AuthDropdown';

// Icons
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

const Avatar_For_Headers = ({
    auth
}) => {

    // Toggle Dropdwon
    const [authDropdown, setAuthDropdown] = useState(false);

    // Close Dropdown if not logged in
    useEffect(() => {
        if(!auth.isAuthenticated){
            if(authDropdown) setAuthDropdown(false);
        }

    }, [auth.user]);

    return (
        <div onClick={() => setAuthDropdown(!authDropdown)} style={{position:'relative', display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
            <div style={{marginRight: '.5rem'}}>
                <KeyboardArrowDownOutlinedIcon />
            </div>

            <div className="post__avatar layoutHeader" style={{marginLeft: '0px', marginTop:'0', marginBottom: '0px'}}>
                <DefaultAvatar name={auth.user.email} size="30" round={true} />
            </div>

            <AuthDropdown setAuthDropdown={setAuthDropdown} authDropdown={authDropdown} />
        </div>
    )
}

Avatar_For_Headers.propTypes = {
    // Prop type validation for authentication
    auth: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    // Mapping the authentication state
    auth: state.auth,
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component

})(Avatar_For_Headers);